"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isChecked;

function isChecked(_ref) {
  var inputValue = _ref.inputValue,
      value = _ref.value,
      defaultValue = _ref.defaultValue;

  if (value) {
    return inputValue === value;
  }

  if (defaultValue) {
    return inputValue === defaultValue;
  }

  return inputValue === 'AM';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/TimePicker/helpers/isChecked.js
// module id = c2b9
// module chunks = 0